/**
 * 请假类型 (0-其它,1-事假,2-病假)
 */

const TYPES = {
  NORMAL: '1',
  SICK: '2',
  OTHER: '0',
}

export const TYPE_NAMES = {
  [TYPES.NORMAL]: '事假',
  [TYPES.SICK]: '病假',
  [TYPES.OTHER]: '其它',
}

export const TYPE_LIST = [
  {
    id: TYPES.NORMAL,
    name: TYPE_NAMES[TYPES.NORMAL],
  },
  {
    id: TYPES.SICK,
    name: TYPE_NAMES[TYPES.SICK],
  },
  {
    id: TYPES.OTHER,
    name: TYPE_NAMES[TYPES.OTHER],
  },
]

export default TYPES
